import { render } from "./LoginBanner.vue?vue&type=template&id=9ef80ef4&scoped=true"
import script from "./LoginBanner.vue?vue&type=script&lang=js"
export * from "./LoginBanner.vue?vue&type=script&lang=js"

import "./LoginBanner.vue?vue&type=style&index=0&id=9ef80ef4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ef80ef4"]])

export default __exports__